window.AuthService = class
{

	onLogout = () => {
		FavListHelper.clear();
		FavListHelper.save();
		location.href = '/logout';
	}

	/**
	 * Evento que se ejecuta al loguearse correctamente
	 * @param data
	 * @returns {Promise<void>}
	 */
	onLogin = async (data) => {

		if(data.favList) {
			FavListHelper.clear();
			FavListHelper.save();
			FavListHelper.insert(data.favList);
			FavListHelper.save();
		}
		// Si el login envio la variable offerWebAuth, significa que en el servidor no encontro ninguna passkey guardada para el user
		if (data.initWebAuth) {
			await this.initWebAuth();
		}

		location.reload();
	}

	/**
	 * Si se cumple los requisitos del browser, muestra un modal ofreciendo registrar una passkey.
	 * @returns {Promise<unknown>}
	 */
	initWebAuth = (alwaysAsk = false) => {
		// Solo si acepta creacion de publickeycredential y no tiene flaggeado el skip

		if((localStorage.getItem('skipPasskeyCreationAtLogin') !== 'true' || alwaysAsk) && 'credentials' in navigator) {

			return new Promise(async(resolve, reject) => {
				// descargar y agregar el modal al DOM
				await Library.twig('passkeyView');

				const modal = new ModalUi({
					callback: {
						onClose: function () {
							// al cerrar el modal continuar la ejecucion donde iba..
							resolve();
						}
					}
				});

				const $modal = await modal.loadFromTemplate('passkeyView.tpl', {});
				modal.render();

				$modal.find('button[role="skip"]').on('click', function () {
					localStorage.setItem('skipPasskeyCreationAtLogin', 'true');
					modal.hide();
				});

				$modal.find('button[role="register"]').on('click', async () => {
					await this.registerWebAuth();
					modal.hide();
				});

			});
		}
	}

	/**
	 * Inicializa el proceso de registro de una nueva passkey
	 * @returns {Promise<void>}
	 */
	registerWebAuth = async () => {
		try {
			let response = await axios.get('/api/auth/register/webauthn');
			let createArgs = response.data;

			UtilityHelper.recursiveBase64StrToArrayBuffer(createArgs);

			const credential = await navigator.credentials.create(createArgs);

			// create object
			const credentialForServer = {
				transports: credential.response.getTransports  ? credential.response.getTransports() : null,
				clientDataJSON: credential.response.clientDataJSON  ? UtilityHelper.arrayBufferToBase64(credential.response.clientDataJSON) : null,
				attestationObject: credential.response.attestationObject ? UtilityHelper.arrayBufferToBase64(credential.response.attestationObject) : null
			};

			response = await axios.post('/api/auth/register/webauthn', credentialForServer);

			console.log(response);

		} catch (error) {
			ErrorHandler.process(error);
		}
	}
};

